







import { Component, Vue } from 'vue-property-decorator'
import ChatWidget from '@/components/ChatWidget.vue'
import firebase from 'firebase/app'
import 'firebase/auth'

@Component({
  components: {
    ChatWidget
  }
})
export default class App extends Vue {
  get isLoggedIn() {
    return !!firebase.auth().currentUser || !!this.$store.state.user.user
  }
}
